<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getTravelInfoTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionTravelInfo && permissionTravelInfo.permission_id === permission.readWrite"
          @click.native="createTravelInfo" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable(header.id)">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">
                {{((dataPaginate.current_page-1)*10)+(index+1)}}
              </td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td align="center">
                <v-img :src="item.icon_active_show" style="width: 40px"></v-img>
              </td>
              <td>{{ item.title_en }}</td>
              <td>
                {{ item.updated_at | moment("DD-MM-YYYY") }}
              </td>
              <td>
                <a @click="showTravelInfoData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputSearch from "../../../components/Input/InputSearch";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import Paginate from "../../../components/Layout/Paginate";
import {permissionTravelInfo, role} from "../../../util/Permission";
import Loading from 'vue-loading-overlay';
import {mapState} from "vuex";
import Swal from 'sweetalert';

export default {
  name: "TravelInfoTable",
  components: {Paginate, IconPencil, CircleButton, InputSearch, Loading },
  data() {
    return {
      title: "Travel Info",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,icon : null},
        { id: 11, text: "Branch" ,icon : true},
        { id: 3, text: "Icon" ,icon : null},
        { id: 4, text: "Title" ,icon : null},
        { id: 22, text: "Update date" ,icon : true},
        { id: 6, text: "edit" ,icon : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort_date : 'desc',
      sort_branch : 'desc',
      sort : 'desc',
    };
  },
  computed: {
    permissionTravelInfo,
  },
  created() {
    this.permission = role;
    this.getTravelInfoTable(1);
  },
  methods: {
    getTravelInfoTable(page) {
      this.isLoading = true;
      this.$store.dispatch("TravelInfo/getTravelInfo", {
        page,
        search : this.search,
        sort_date : this.sort_date,
        sort_branch : this.sort_branch,
      }).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getTravelInfoTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    showTravelInfoData(id) {
      this.isLoading = true;
      this.$store.dispatch("TravelInfo/showTravelInfo", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("TravelInfo/setFormTravelInfo", res.result).then(() => {
            this.goToTravelEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    createTravelInfo() {
      this.$store.dispatch("TravelInfo/clearFormData").then(() => {
        this.goToTravelEdit();
      });
    },
    goToTravelEdit() {
      this.$router.push("/travel-info/edit");
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(header_id){
      this.sort = this.sort == 'desc' ? 'asc' : 'desc';
      if(header_id === 11){ //sort by branch
        this.sort_branch = this.sort_branch == 'desc' ? 'asc' : 'desc';
      }
      if(header_id === 22){ //sort by updated_at
        this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
      }
      this.getTravelInfoTable(1);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables.scss";
.branch-data {
  background-color: $background-theme;
  margin: $margin-search;
}
</style>
